/* eslint-disable */
// This file is automatically generated and should not be edited directly.
// Please edit the corresponding SVG file

import React from 'react';

const ArrowLeft = (props: any) => (
<svg {...props}   viewBox="0 0 32 32" fill="inherit" xmlns="http://www.w3.org/2000/svg">
<g id="32px/arrow-left">
<path id="Arrow 4" d="M26 15C26.5523 15 27 15.4477 27 16C27 16.5523 26.5523 17 26 17L26 15ZM5.29289 16.7071C4.90237 16.3166 4.90237 15.6834 5.29289 15.2929L11.6569 8.92893C12.0474 8.53841 12.6805 8.53841 13.0711 8.92893C13.4616 9.31946 13.4616 9.95262 13.0711 10.3431L7.41421 16L13.0711 21.6569C13.4616 22.0474 13.4616 22.6805 13.0711 23.0711C12.6805 23.4616 12.0474 23.4616 11.6569 23.0711L5.29289 16.7071ZM26 17L6 17L6 15L26 15L26 17Z" fill="#282828"/>
</g>
</svg>
);

export default ArrowLeft;